// extracted by mini-css-extract-plugin
module.exports = {"action":"EditableListButtons__action--IGqFG"};